// cpaData.js
export const cpaLevels = {
  foundational: [
    { name: "Financial Accounting", slug: "financial-accounting" },
    { name: "Communication Skills", slug: "communication-skills" },
    { name: "Economics", slug: "economics" },
    { name: "ICT", slug: "ict" },
    { name: "Introduction to Law", slug: "introduction-to-law" },
    { name: "Quantitative Analysis", slug: "quantitative-analysis" }
  ],
  intermediate: [
    { name: "Auditing", slug: "auditing" },
    { name: "Company Law", slug: "company-law" },
    { name: "Financial Management", slug: "financial-management" },
    { name: "Financial Reporting", slug: "financial-reporting" },
    { name: "Management Accounting", slug: "management-accounting" },
    { name: "Public Finance & Taxation", slug: "taxation" }
  ],
  advanced: [
    { name: "Advanced Financial Management", slug: "advanced-management-accounting" },
    { name: "Advanced Financial Management", slug: "advanced-financial-management" },
    { name: "Advanced Public Management", slug: "public-management" },
    { name: " Advanced Data Analytics", slug: "data-analytics" },
    { name: "Advanced Auditing & Assurance", slug: "advanced-auditing" },
    { name: "Advanced Financial Reporting", slug: "advanced-financial-reporting" },
    { name: "Advanced Leadership & Management", slug: "leadership" },
    { name: "Advanced PubFin & Taxation", slug: "advanced-taxation" }
  ]
};